import { styled } from 'troyfe'
const Block = styled.div`
  display: flex;
  /* width: 100%; */
  padding: 14px 16px 0;
  position: relative;
  .left {
    /* 已认证楼盘信息 */
    width: 24vw;
    padding-right: 16px;
    border-right: 1px solid #f1f2f4;
    .control-block {
      .control-user {
        border-bottom: 1px solid #f1f2f4;
        padding-bottom: 45px;
        .control-inf {
          display: flex;
          align-items: center;
          .user-text {
            border-radius: 50%;
            width: 44px;
            height: 44px;
            color: #fff;
            background: #44bb55;
            text-align: center;
            line-height: 44px;
          }
          img {
            width: 44px;
            height: 44px;
          }
        }
        .control-text {
          margin-left: 15px;
          h1 {
            font-size: 20px;
            color: #1b1b1d;
            font-weight: bold;
          }
          i {
            display: inline-block;
            margin: 0 10px;
            width: 1px;
            height: 10px;
            background: #e2e2e2;
          }
          div {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-top: 6px;
            span {
              color: #44bb55;
            }
          }
        }
        .control-admin {
          display: flex;
          align-items: center;
          margin-top: 40px;
          h1 {
            font-size: 14px;
            color: #1b1b1d;
            font-weight: bold;
          }
          .vice- {
            margin-left: 50px;
          }
          .main,
          .vice- {
            ul {
              display: flex;
              margin-top: 10px;
              i {
                display: inline-block;
                width: 1px;
                background: #e2e2e2;
              }
              .circular {
                border-radius: 50%;
              }
              li {
                background: #44bb55;
                font-size: 12px;
                width: 36px;
                height: 36px;
                line-height: 36px;
                text-align: center;
                margin-right: 8px;
                color: #fff;
              }
              .more {
                cursor: pointer;
                background: #f1f2f4;
                color: #999999;
              }
            }
          }
        }
        .certifiedBuilding {
          span {
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
      .control-summary {
        width: 100%;
        padding: 24px 0;
        height: 188px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        border-bottom: 1px solid #f1f2f4;
        li {
          width: calc(100% / 2);
          text-align: left;
          label {
            color: #1b1b1d;
            font-size: 14px;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
          }
          p {
            margin-top: 8px;
          }
        }
      }
      .buildingAuthentication {
        padding: 24px 0;
        border-bottom: 1px solid #f1f2f4;
        p {
          color: #1b1b1d;
          font-size: 14px;
          font-weight: 400;
        }
        .limit {
          margin-top: 24px;
          display: flex;
          justify-content: space-between;
          div {
            img {
              width: 44px;
              height: 44px;
              margin-right: 20px;
              border-radius: 50%;
            }
          }
          .button {
            height: fit-content;
            color: #ffffff;
            padding: 11px 32px;
            border-radius: 8px;
            background: #44bb55;
            cursor: pointer;
          }
        }
      }
      .control-role {
        width: 100%;
        padding: 24px 0 0;
        display: flex;
        flex-wrap: wrap;
        li {
          width: calc(100% / 2);
          text-align: left;
          margin-bottom: 20px;
          font-size: 14px;
          div {
            color: #1b1b1d;
            display: flex;
            align-items: center;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            span {
              /* cursor: pointer; */
              color: #44bb55;
              margin-left: 10px;
            }
          }
          p {
            margin-top: 8px;
          }
        }
      }
    }
  }
  .right {
    flex: 1;
    padding-left: 17px;
    .quick-block {
      width: 100%;
      .carousel {
        cursor: pointer;
        img {
          width: 100%;
          height: 200px;
        }
      }

      .quick-download,
      .quick-entrance {
        width: 100%;
        h1 {
          font-size: 16px;
          color: #1b1b1d;
          font-weight: bold;
        }
      }
      .quick-entrance {
        margin-top: 24px;
        ul {
          min-height: 200px;
          padding: 16px 0 0;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          li {
            min-width: 200px;
            display: flex;
            align-items: center;
            font-size: 14px;
            padding: 14px;
            cursor: pointer;
            color: #666666;
            margin-bottom: 16px;
            margin-right: 16px;
            border-radius: 8px;
            border: 1px solid #f1f2f4;
            img {
              width: 36px;
              height: 36px;
              margin-right: 12px;
            }
            &:hover {
              border: 1px solid #44bb55;
            }
          }
        }
      }
      .quick-download {
        margin-top: 8px;
        ul {
          margin-top: 16px;
          display: flex;
          align-items: center;
          li {
            margin-right: 40px;
            font-size: 14px;
            color: #666666;
            img {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
          }
        }
      }
    }
    .app {
      width: 100%;
      h1 {
        margin: 32px 0 8px 0;
        font-size: 16px;
        font-weight: bold;
        color: #1b1b1d;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        li {
          display: flex;
          cursor: pointer;
          min-width: 200px;
          align-items: center;
          margin-top: 16px;
          margin-right: 16px;
          padding: 14px 0 14px 14px;
          border: 1px solid #f1f2f4;
          border-radius: 8px;
          img {
            display: inline-block;
            width: 36px;
            height: 36px;
            margin-right: 12px;
          }
          label {
            font-size: 14px;
            color: #1b1b1d;
          }
          &:hover {
            border: 1px solid #44bb55;
          }
        }
      }
    }
  }
`
export default Block
